import React from "react";
import { Input } from "antd";
import formatAccountNumber from "./formatAccountNumber";

const BankAccountInput = ({ disabled, value, onChange }) => {
	const BANK_ACCOUNT_LENGTH = 26; // Example length for a Polish IBAN

	// Format the input with the first two digits followed by groups of 4

	// Check if the account number is valid
	const isValidAccountNumber = (number) => {
		const digitsOnly = number.replace(/\s+/g, ""); // Strip spaces
		return digitsOnly.length === BANK_ACCOUNT_LENGTH; // Match exact length
	};

	const isValid = isValidAccountNumber(value || "");

	// Handle change and format input
	const handleChange = (e) => {
		const rawValue = e.target.value.replace(/\s+/g, ""); // Remove spaces
		if (!/^\d*$/.test(rawValue)) return; // Only allow numeric input
		onChange(formatAccountNumber(rawValue)); // Format the input value
	};

	return (
		<Input
			className="bankaccount"
			disabled={disabled}
			status={isValid ? undefined : "error"}
			addonAfter={
				isValidAccountNumber(value) ? (
					<span style={{ color: "green" }}>✔</span>
				) : (
					<span style={{ color: "red" }}>✖</span>
				)
			}
			value={formatAccountNumber(value || "")}
			onChange={handleChange}
		/>
	);
};

export default BankAccountInput;
